<script lang="ts" setup>
import DetailsAndAddToCart from "~/components/product/DetailsAndAddToCart.vue";
import AdditionalDetails from "~/components/product/AdditionalDetails.vue";
import RecentlyViewed from "~/components/home/RecentlyViewed.vue";
import AdditionalBooks from "~/components/home/AdditionalBooks.vue";
import MightLikeBooks from "~/components/home/MightLikeBooks.vue";
import { ref } from "vue";
import { useHelper } from "~/composables/helper";

// Data
const route = useRoute();
const filtersAndFields = [`fields=${useHelper().collectionProductFields}`];
const slugOrId = (route.params["product"] ?? "") as string;
filtersAndFields.push(isNaN(+slugOrId) ? `filter[slug:is]=${slugOrId}` : `filter[id:is]=${slugOrId}`);
const products = ref([]);
products.value = await useHelper().getCollection("products", filtersAndFields.join("&"), 1);

if (!products.value || products.value?.length <= 0) {
    await navigateTo("/");
}
const product = ref({});
product.value = products.value ? products.value[0] : {};

const userState = ref("");

onMounted(async () => {
    userState.value = (await useUserStore().fetchUserState()) ?? "ga";

    useTrackEvent("view_item", {
        product_id: product.value.id,
        product_name: product.value.title,
        product_isbn: product.value.isbn,
    });
});
</script>

<template>
    <div v-if="product" class="py-6">
        <DetailsAndAddToCart :product="product" />

        <hr class="mx-4 mt-4 mb-2 md:hidden" />

        <AdditionalDetails :product="product" class="md:mt-6" />

        <AdditionalBooks :product="product" :state="userState" class="mt-20" />
        <MightLikeBooks :product="product" :state="userState" class="mt-10" />
        <RecentlyViewed class="mt-10" />
    </div>
</template>

<style scoped></style>
